import React from "react"
// import Avatar from "@mui/material/Avatar"
import Button from "@mui/material/Button"
import { Mail, Phone, Pen } from "lucide-mui"
import { Link, LinkProps } from "react-router-dom"
import { usePanelLinkWithPageParams } from "@/shared/hooks"
import i18n from "@/i18n"
import Chart from "@/components/reservations/edit_form/chart"

const OtherLink = (props: LinkProps) => (
  <Link
    {...props}
    className={
      "text-blue-700 hover:text-blue-500 focus:text-blue-700 no-underline hover:no-underline focus:no-underline transition duration-300 ease-in-out"
    }
  />
)

const AlsoKnownAs = ({ customer, customerContact }) => {
  const linkTo = usePanelLinkWithPageParams()

  if (customer.customerContacts.length === 1) {
    return null
  }

  const otherContacts = customer.customerContacts.filter((contact) => contact.id !== customerContact.id)

  return (
    <div className="text-gray-500 text-xs mt-2 max-w-sm">
      {i18n.t("app.clients.client_modal.also_known_as")}{" "}
      {otherContacts.slice(0, 3).map((contact, index) => (
        <React.Fragment key={contact.id}>
          <OtherLink to={linkTo(`clients/${contact.id}`)}>{contact.name}</OtherLink>
          {index !== 2 && index < Math.min(2, otherContacts.length - 1) && <span className="mr-0.5">,</span>}
        </React.Fragment>
      ))}
      {otherContacts.length > 3 && (
        <OtherLink to={linkTo(`clients?query=${customerContact.email}&page=1`)}>
          {" "}
          {i18n.t("app.clients.client_modal.and_others", { count: otherContacts.length - 3 })}
        </OtherLink>
      )}
    </div>
  )
}

interface CustomerDetailsViewProps {
  customer: any
  customerContact: any
  onEdit: () => void
}

const CustomerDetailsView: React.FC<CustomerDetailsViewProps> = ({ customer, customerContact, onEdit }) => {
  return (
    <div data-testid="panel-clients-modal-details-view-container" className="flex flex-col h-full">
      <div className="flex flex-col mb-8">
        <h2
          data-testid="panel-clients-modal-details-view-name"
          className="mt-0 mb-4 text-2xl font-semibold text-gray-700"
        >
          {customerContact.name}
        </h2>

        <div data-testid="panel-clients-modal-details-view-phone" className="flex items-center mb-2 text-base">
          <Phone fontSize="inherit" className="mr-3 text-gray-500" />
          <span className="text-gray-700">{customerContact.phoneFormatted}</span>
        </div>
        <div data-testid="panel-clients-modal-details-view-email" className="flex items-center text-base">
          <Mail fontSize="inherit" className="mr-3 text-gray-500" />
          <span className="text-gray-700">{customerContact.email}</span>
        </div>
        <AlsoKnownAs customer={customer} customerContact={customerContact} />
        <div className="mt-4">
          <Button
            data-testid="panel-clients-modal-details-view-edit-btn"
            size="small"
            startIcon={<Pen className="text-sm" />}
            onClick={onEdit}
          >
            {i18n.t("app.clients.client_modal.edit_button")}
          </Button>
        </div>
      </div>
      <div
        data-testid="panel-clients-modal-details-view-stats"
        className="border-0 border-t border-solid border-gray-200 pt-6 mb-4"
      >
        <Chart stats={customer.stats} />
      </div>
    </div>
  )
}

export default CustomerDetailsView
